import { ResizablePanel } from '@art-of-hospitality-solutions-llc/ui-kit/components/resizable';

interface LayerSidebarProps {
  children: React.ReactNode;
}

/** Resizable layers pane; the divider to its right is the visual border. */
export default function LayerSidebar({ children }: LayerSidebarProps) {
  return (
    <ResizablePanel
      defaultSize={16}
      minSize={12}
      maxSize={30}
      className="flex min-w-0 flex-col items-stretch"
    >
      {children}
    </ResizablePanel>
  );
}
